import { render, staticRenderFns } from "./donation.vue?vue&type=template&id=072ab90a&scoped=true&"
import script from "./donation.vue?vue&type=script&lang=js&"
export * from "./donation.vue?vue&type=script&lang=js&"
import style0 from "./donation.vue?vue&type=style&index=0&id=072ab90a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072ab90a",
  null
  
)

export default component.exports